import { z } from "zod";

import { InvoiceSystemSettingsInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

const ERROR_MESSAGES = {
	validRegistrationCode: "登録番号は13文字にしてください",
};

/**
 *
 * @description インボイスに関する情報設定用のバリデーションスキーマ
 */
export const InvoiceSystemSettingsInputZodSchema = InvoiceSystemSettingsInputSchema.extend({
	registrationCode: z
		.string()
		.min(13, ERROR_MESSAGES.validRegistrationCode)
		.max(13, ERROR_MESSAGES.validRegistrationCode)
		.nullish(),
});

export type InvoiceSystemSettingsInputZodSchemaType = z.infer<typeof InvoiceSystemSettingsInputZodSchema>;

export type InvoiceSystemSettingsInputZodParseError = ZodError<InvoiceSystemSettingsInputZodSchemaType>;
